module.exports = __webpack_public_path__ + "static/img/10.559ede8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/1/zh/10.png
// module id = m8XI
// module chunks = 0